import { Col, Container, Row, Avatar, Tag, Typography } from 'darrius';

import { Dialog } from '../../../components';

import styles from './AdsDetailDialog.module.scss';
import { triggerEvent } from '../../../utils/triggerEvent';

interface IAdsDetailDialogProps {
  avatar: string;
  name: string;
  category: string;
  description: string;
  requestId: string;
  profileId: string;
}

export function AdsDetailDialog({
  avatar,
  name,
  category,
  description,
  requestId,
  profileId,
}: IAdsDetailDialogProps) {
  const handleTriggerEventCloseModal = () => {
    triggerEvent('instant-match_service-sale-ads__close-modal', {
      requestId: requestId,
      profileId: profileId,
    });
  };

  return (
    <Dialog.Portal>
      <Dialog.Content
        className={`ads-detail-dialog ${styles['ads-detail-dialog']}`}
      >
        <Container
          className={`container ${styles['ads-detail-dialog__container']}`}
        >
          <div onClick={handleTriggerEventCloseModal}>
            <Dialog.Close
              className={`${styles['ads-detail-dialog__close']} dialog__close`}
            />
          </div>

          <Row>
            <Col>
              <Row>
                <Col
                  className={`${styles['ads-detail-dialog__head-content']} col-sm-12`}
                >
                  <div>
                    <Avatar
                      src={avatar}
                      alt="Imagem do profissional"
                      size="48px"
                      className={styles['profile-avatar']}
                      fallback={{
                        variant: 'byName',
                        name,
                      }}
                    />
                  </div>

                  <div className={`${styles['ads-detail-dialog__title']}`}>
                    <p className={styles.name}>{name}</p>
                    <p className={styles.category}>{category}</p>

                    <div className={`${styles['ads-detail-dialog__tags']}`}>
                      <div className={`${styles.service} action`}>
                        <Tag className="action">Serviço garantido</Tag>
                      </div>

                      <div className={`${styles.payment} action`}>
                        <Tag className="action">Pagamento seguro</Tag>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col
                  className={`${styles['ads-detail-dialog__description']} col-sm-12`}
                >
                  <Typography.Subtitle size="m">
                    Esse serviço atende:
                  </Typography.Subtitle>
                  <Typography.Text
                    className={styles['ads-detail-dialog__text']}
                  >
                    {description}
                  </Typography.Text>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Dialog.Content>
    </Dialog.Portal>
  );
}
